import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const files = require.context('@/view', true, /\.vue$/)
let views = {}
let viewsfile = []
files.keys().forEach(key => {
  let routekey = key.substring(2)
  let newkey = routekey.slice(0, -4)
  viewsfile.push(newkey)
  views[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default
})
// 生成路由规则 懒加载
let generator = []
Object.keys(views).forEach((item, index) => {
  generator.push({
    path: `/${views[item].name.replace(/-/g, '/')}`,
    name: views[item].name,
    meta: views[item].meta,
    component: resolve => require([`@/view/${viewsfile[index]}`], resolve)
  })
})
// 合并公共路由以及重定向规则
const routers = [...generator]
// console.log(routers)
export default new Router({ routes: routers })

// import Login from '@/view/user/login'
// import Register from '@/view/user/register'
// import Forget from '@/view/user/forget'
// import informationList from '@/view/information/list'
// import informationDetail from '@/view/information/detail'
// import venueList from '@/view/venue/list'
// import venueDetail from '@/view/venue/detail'
// import venueEnroll from '@/view/venue/enroll'
//
// Vue.use(Router)
//
// export default new Router({
//   routes: [
//     {
//       path: '/login',
//       name: 'login',
//       component: Login,
//       meta: {
//         title: '登录',
//         showHeader: false
//       }
//     },
//     {
//       path: '/register',
//       name: 'register',
//       component: Register,
//       meta: {
//         title: '注册'
//       }
//     },
//     {
//       path: '/forget',
//       name: 'forget',
//       component: Forget,
//       meta: {
//         title: '忘记密码'
//       }
//     },
//     {
//       path: '/informationlist',
//       name: 'informationlist',
//       component: informationList,
//       meta: {
//         showHeader: true
//       }
//     },
//     {
//       path: '/informationdetail',
//       name: 'informationdetail',
//       component: informationDetail,
//       meta: {
//         showHeader: true
//       }
//     },
//     {
//       path: '/venuelist',
//       name: 'venuelist',
//       component: venueList,
//       meta: {
//         showHeader: true
//       }
//     },
//     {
//       path: '/venuedetail',
//       name: 'venuedetail',
//       component: venueDetail,
//       meta: {
//         showHeader: true
//       }
//     },
//     {
//       path: '/venueenroll',
//       name: 'venueenroll',
//       component: venueEnroll,
//       meta: {
//         showHeader: true
//       }
//     }
//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js